<template>
  <div v-if="sections!=null" :class="shouldFill ? 'mobile-version-player' : ''">
    <div class="main-background" :style="'background-image:url(' + mainBackground.image + ');'"></div>
    <scrollsection :id="'page_marker_' + v.title.split(' ').join('_')" role="region" :aria-label="v.title" v-for="(v, i) in sections" :key="'section'+i.toString()" :topoffset="v.shared ? sharedOffset.top : 0" :index="i" :first="i == 0" :last="i == sections.length - 1" :shared="v.shared" :zone="currentZone" :bgstyle="renderSectionStyle(v, i)" :sidemargin="v.background.image.marginLeft ? v.background.image.marginLeft : 0" :mobiletop="mobileTops[i]" :mobileheight="mobileHeight">
      
      <!-- <div slot="background" class="section-background"></div> -->
      <!-- <video class="section-bg-video" v-if="v.background.video" autoplay loop>
        <source v-for="(vid, k, j) in v.background.video" :key="k+'.'+i.toString()+'.'+j.toString()" :src="vid" :type="'video/'+k" />
      </video> -->
      <iframe v-if="v.background.frame" slot="bgframe" class="section-bg-video" :src="v.background.frame"></iframe>
      <div :id="'inner_section_'+i.toString()" class="section-inner" slot="content">
        <!-- <div :id="'page_marker_' + v.title.split(' ').join('_')"></div> -->
        <div v-if="v.shouldRender || v.shared" v-for="(w, j) in v.widgets" :key="'widget'+i.toString()+'.'+j.toString()">
          <widgetshell :widget="w" :section="v" :index="i" :zone="v.shared ? currentZone : -1"></widgetshell>
        </div>
        <div class="corona-site-dashed-line" style="position:absolute;top:73px;left:266px;height:5000px;width:2px;" v-if="i==1 && site == ''"></div>
        <div class="corona-site-dashed-line" style="position:absolute;top:-1000px;left:266px;height:5000px;width:2px;" v-else-if="i>1 && site == ''">LINE</div>
        <wavenav v-if="i == 0 && (currentZone == 0 || GeneralUtils.isMobile()) && site == ''" :zone="currentZone" />
      </div>
      <header v-if="!inFrame" slot="header" class="cvm-header">
        <div :style="site == 'casestudy' ? 'padding-top:20px;' : ''">
          <a href="http://gongos.com/?show_microsite=false" target="_blank"><img src="/corona_microsite/static/images/item-4-0.png" /></a>
          <a v-if="site == 'casestudy'" href="http://disqo.com/" target="_blank"><img style="height:35px; padding-left: 50px;" src="/corona_microsite/static/images/section1015/item-6-15.png" /></a>
        </div>
      </header>
      <!-- <footer v-if="!inFrame || (!mobileAlternate && !GeneralUtils.isMobile())" slot="footer" class="cvm-footer">
        <div>
          <a href="http://gongos.com/?show_microsite=false" target="_blank"><img src="/corona_microsite/static/images/item-4-0.png" /></a>
          <div>
            <p>Visit us at <a href="http://gongos.com/?show_microsite=false" target="_blank">gongos.com</a></p>
            <p>&copy; Copyright 2020, Gongos, Inc.</p>
          </div>
        </div>
      </footer> -->
    </scrollsection>
    <ul :class="'section-navigation '+sections[currentZone].menuClass">
      <li v-if="!v.shared" v-for="(v, i) in sections" :key="'section_marker'+i.toString()" v-on:click="goToSection(i)" :class="currentZone == i ? 'active-marker' : 'inactive-marker'">
        <div :class="sections[currentZone].menuClass"></div><label :class="sections[currentZone].menuClass">{{v.title.toUpperCase()}}</label>
      </li>
    </ul>
    <wavenav v-if="!GeneralUtils.isMobile() && currentZone > 0 && site == ''" :zone="currentZone" />
    <sitenav v-if="site != ''" :sections="sitNavSections" :sectiontotal="sections.length"></sitenav>
  </div>
  <div class="loading-bar" v-else></div>
</template>

<script>
import {EventBus} from './utils/EventBus.js'
import {TweenLite, Sine} from 'gsap'
import GeneralUtils from './utils/GeneralUtils.js'
import ScrollSection from './ScrollSection.vue'
import WidgetShell from './WidgetShell.vue'
import WidgetUtils from './utils/WidgetUtils.js'
import Sections from './utils/Sections.js'
import WaveNav from '../custom/WaveNav.vue'
import SiteNav from '../custom/SiteNav.vue'
export default {
  props: ['dirs'],
  components: {
    scrollsection: ScrollSection,
    widgetshell: WidgetShell,
    wavenav: WaveNav,
    sitenav: SiteNav
  },
  name: 'app',
  data () {
    return {
      GeneralUtils: GeneralUtils,
      WidgetUtils: WidgetUtils,
      site: Sections.getSite(),
      inFrame: Sections.inFrame(),
      mobileAlternate: Sections.mobileAlternate(),
      currentZone: 0,
      innerStyles: [],
      innerScale: 1.5,
      shouldFill: Sections.mobileAlternate() && GeneralUtils.isMobile() && !Sections.shouldStack(),
      mainBackground: {
        image: 'src/assets/main_background.jpg'
      },
      sharedOffset: {
        top: 0,
        zone: 0
      },
      scrollProps: {
        tick: 100,
        shouldPerformCorrection: true
      },
      sections: null,
      msg: 'Welcome to Your Vue.js App',
      scaleFactor: 1,
      minimumAspectRatio: 1.7,
      sitNavSections: [],
      mobileTops: [],
      mobileHeight: 0
    }
  },
  methods: {
    renderSectionStyle: function (section, index) {
      let self = this
      var styleString = ''
      if (section.background) {
        if (section.background.color) {
          styleString += 'background-color:' + section.background.color + ';'
        }
        if (section.background.image) {
          styleString += 'background-image:url("' + section.background.image.url + '");'
          styleString += 'background-size:' + section.background.image.size + ';'
          styleString += 'background-position:' + section.background.image.position + ';'
          styleString += 'background-repeat:' + section.background.image.repeat + ';'
        }
      }
      return styleString
    },
    adjustTopOffset: function (suspend) {
      var self = this
      if (self.$data.currentZone !== self.$data.sharedOffset.zone) {
        self.$data.sharedOffset.zone = self.$data.currentZone
        TweenLite.to(self.$data.sharedOffset, 0.5, {
          top: self.$data.currentZone * GeneralUtils.getWindowSize().height,
          ease: Sine.inOut,
          onComplete: function () {
            if (!suspend) {
              self.adjustTopOffset(true)
            }
          }
        })
      }
    },
    pageScrolled: function (e) {
      var self = this
      // if (!GeneralUtils.isMobile()) {
      self.$data.scrollProps.tick = 100
      for (var i = 0; i < self.$data.sections.length; i++) {
        if (GeneralUtils.getMainScrollElement().scrollTop >= i * GeneralUtils.getHeight() - (GeneralUtils.getWindowSize().height / 2) || GeneralUtils.isMobile()) {
          self.$data.sections[i].shouldRender = true
        }
        self.$data.currentZone = WidgetUtils.getCurrentZone(self.$data.sections.length)
        // console.log(i.toString() + 'current zone = ' + self.$data.currentZone)
      }
      if (self.$data.scrollProps.shouldPerformCorrection) {
        // TweenLite.to(self.$data.scrollProps, 0.25, {tick: 0, onComplete: self.scrollCorrection})
        self.adjustTopOffset()
      }
      // self.scrollCorrection()
      // }
    },
    scrollCorrection: function () {
      var self = this
      if (self.$data.scrollProps.tick === 0 && self.$data.scrollProps.shouldPerformCorrection) {
        self.goToSection(self.findClosestSection(), 0.25)
      }
      // setTimeout(self.scrollCorrection, 100)
    },
    findClosestSection: function () {
      var lowestDist = 99999999
      var targetIndex = -1
      // var verticalCenter = GeneralUtils.getMainScrollElement().scrollTop + (GeneralUtils.getWindowSize().height / 2)
      var inlineSections = document.getElementsByClassName('inline-section')
      for (var i = 0; i < inlineSections.length; i++) {
        // console.log(inlineSections[i].getBoundingClientRect().top + (GeneralUtils.getWindowSize().height / 2))
        var dist = Math.abs((inlineSections[i].getBoundingClientRect().top + (GeneralUtils.getWindowSize().height / 2)) - (GeneralUtils.getWindowSize().height / 2))
        if (dist < lowestDist) {
          lowestDist = dist
          targetIndex = i
        }
      }
      return targetIndex
    },
    goToSection: function (index, duration) {
      var self = this
      self.$data.currentZone = index
      var _duration = !duration ? 0.75 : duration
      self.$data.scrollProps.shouldPerformCorrection = false
      if (index < self.$data.sections.length && index >= 0) {
        var scrollStats = {top: GeneralUtils.getMainScrollElement().scrollTop}
        TweenLite.to(scrollStats, _duration, {
          top: GeneralUtils.getHeight() * (index),
          onUpdate: function (stats) {
            GeneralUtils.getMainScrollElement().scrollTop = stats.top
            self.$data.scrollProps.shouldPerformCorrection = false
            // document.getElementsByTagName('html')[0].scrollTo(0, stats.top)
          },
          onUpdateParams: [scrollStats],
          onComplete: function () {
            self.$data.sections[index].shouldRender = true
            setTimeout(function () {
              self.$data.scrollProps.shouldPerformCorrection = true
            }, 500)
          }
        })
      }
      self.adjustTopOffset()
    },
    getMobileSizeCalculation: function () {
      return window.innerWidth / 300
    },
    getInnerStyle: function (isShared) {
      var self = this
      var baseSize = 700
      var calculatedMobileWidth = self.getMobileSizeCalculation()
      var scale = GeneralUtils.isMobile() ? (0.275 * calculatedMobileWidth) : (GeneralUtils.getWindowSize().height / baseSize) * self.$data.scaleFactor
      if (Sections.mobileAlternate() && GeneralUtils.isMobile() && !Sections.shouldStack()) {
        scale = Sections.inFrame() ? window.innerWidth / 1250 : .8
      }
      var high = GeneralUtils.isMobile() ? GeneralUtils.getMobileHeight() : GeneralUtils.getMinHeight()
      var marginVal = GeneralUtils.isMobile() ? high : GeneralUtils.getMinHeight()
      var standardStyle = 'width:' + GeneralUtils.getMinWidth().toString() + 'px;height:' + high.toString() + 'px;margin-left:' + (GeneralUtils.getMinWidth() / -2).toString() + 'px;margin-top:' + (marginVal / -2).toString() + 'px;transform:scale(' + scale.toString() + ')'
      var marginTopShared = marginVal / -2
      // console.log(GeneralUtils.getWindowSize())
      // if (GeneralUtils.getWindowSize().height < GeneralUtils.getMinHeight() && isShared) {
      //   marginTopShared = GeneralUtils.getWindowSize().height / -2
      // }
      var sharedStyle = 'width:' + GeneralUtils.getMinWidth().toString() + 'px;height:' + high.toString() + 'px;margin-left:' + (GeneralUtils.getMinWidth() / -2).toString() + 'px;margin-top:' + marginTopShared.toString() + 'px;position: absolute;transform:scale(' + scale.toString() + ')'
      // var sharedStyle = 'width:' + self.GeneralUtils.getMinWidth().toString() + 'px;height:0px;margin-left:' + (self.GeneralUtils.getMinWidth() / -2).toString() + 'px;margin-top:' + (self.GeneralUtils.getMinHeight() / -2).toString() + 'px;top:' + (window.innerHeight - (self.GeneralUtils.getMinHeight() / 2)).toString() + 'px !important;position: fixed;'
      // var sharedStyle = 'width:' + self.GeneralUtils.getMinWidth().toString() + 'px;height:0px;margin-left:' + (self.GeneralUtils.getMinWidth() / -2).toString() + 'px;margin-top:0px;top:' + ((self.GeneralUtils.getHeight() / 2) - (self.GeneralUtils.getMinHeight() / 2)).toString() + 'px !important;position: fixed;'
      return isShared ? sharedStyle : standardStyle
    },
    setInnerStyles: function (isShared, index) {
      var self = this
      var sectionElement = document.getElementById('inner_section_' + index.toString())
      if (sectionElement) {
        sectionElement.setAttribute('style', self.getInnerStyle(isShared))
      }
    },
    manageAspectRatio () {
      var self = this
      var size = GeneralUtils.getWindowSize()
      var aspect = size.width / size.height
      if (aspect < self.$data.minimumAspectRatio) {
        self.$data.scaleFactor = aspect / self.$data.minimumAspectRatio
      }
      return aspect
    },
    setVerticals: function () {
      let self = this
      let inlineSections = document.querySelectorAll('div.inline-section')
      self.$data.mobileTops = []
      let baseVert = self.$data.site == '' ? (200 * self.getMobileSizeCalculation()) : (165 * self.getMobileSizeCalculation())
      for (let i = 0; i < inlineSections.length; i++) {
        // console.log(((600 * self.getMobileSizeCalculation()) * i).toString() + 'px !important;')
        // self.$data.mobileTop = (600 * self.getMobileSizeCalculation()) * i
        self.$data.mobileTops.push(baseVert * i)
      }
      self.$data.mobileHeight = baseVert
    }
  },
  mounted: function () {
    var self = this
    // document.getElementsByTagName('html')[0].setAttribute('style', 'background-image:url("' + self.$data.mainBackground.image + '");')
    self.manageAspectRatio()
    EventBus.$on('scroll-section-ease-complete', (n) => {
      self.goToSection(n.index)
    })
    Sections.getSectionsByList(
      self.dirs,
      (d) => {
        // console.log(d)
        self.$data.sections = d
        for (var i = 0; i < self.$data.sections.length; i++) {
          if (self.$data.sections[i].title !== '') {
            self.$data.sitNavSections.push({title: self.$data.sections[i].title, index: i})
          }
          for (var j = 0; j < self.$data.sections[i].widgets.length; j++) {
            // console.log(self.$data.sections[i].widgets[j].font)
            if (self.$data.site !== '' && self.$data.sections[i].widgets[j].properties.text !== undefined && self.$data.sections[i].widgets[j].properties.font === 'Calluna-Light') {
              self.$data.sections[i].widgets[j].properties.text = '<span style="letter-spacing: 1.2px; line-height: ' + (self.$data.sections[i].widgets[j].properties.size * 1.3).toString() + 'px;display:block;">' + self.$data.sections[i].widgets[j].properties.text + '</span>'
            }
          }
          self.setInnerStyles(self.$data.sections[i].shared, i)
          // self.$data.innerStyles[i] = self.getInnerStyle(self.$data.sections[i].shared)
        }
        window.addEventListener('scroll', self.pageScrolled)
        if (!GeneralUtils.isMobile()) {
          window.addEventListener('resize', function () {
            self.goToSection(self.$data.currentZone)
            // console.log(self.manageAspectRatio())
            if (GeneralUtils.isMobile()) {
              let inlineSections = document.querySelectorAll('div.inline-section')
              for (let i = 0; i < inlineSections.length; i++) {
                inlineSections[i].style.top = ((600 * self.getMobileSizeCalculation()) * index).toString() + 'px !important;';
              }
              // styleString += 'top:' + ((600 * self.getMobileSizeCalculation()) * index).toString() + 'px !important;'
            }
          })
          // setTimeout(self.manageAspectRatio, 200)
        } else {
          window.addEventListener('resize', function () {
            if (Sections.inFrame()) {
              self.setVerticals()
            }
            // setTimeout(function () {
            //   for (let i = 0; i < inlineSections.length; i++) {
            //     console.log(((600 * self.getMobileSizeCalculation()) * i).toString() + 'px !important;')
            //     mobileTop = (600 * self.getMobileSizeCalculation()) * i
            //   }
            // }, 100)
            // styleString += 'top:' + ((600 * self.getMobileSizeCalculation()) * index).toString() + 'px !important;'
          })
        }
        self.pageScrolled()
        if (Sections.inFrame()) {
          document.querySelector('html').setAttribute('style', 'box-shadow:none !important;')
          document.querySelector('body').setAttribute('style', 'box-shadow:none !important;')
        }
        setTimeout(self.setVerticals, 100)
      },
      (err) => {
        console.log(err)
      }
    )
    // Sections.loadSections((d) => {
    //   console.log(d)
    //   self.$data.sections = d
    //   for (var i = 0; i < self.$data.sections.length; i++) {
    //     self.setInnerStyles(self.$data.sections[i].shared, i)
    //     // self.$data.innerStyles[i] = self.getInnerStyle(self.$data.sections[i].shared)
    //   }
    //   window.addEventListener('scroll', self.pageScrolled)
    //   self.pageScrolled()
    // }, (err) => {
    //   console.log(err)
    // })
    EventBus.$on('scroll-section-ease-resized', (n) => {
      self.setInnerStyles(n.shared, n.index)
      self.$data.currentZone = WidgetUtils.getCurrentZone(self.$data.sections.length)
      self.adjustTopOffset()
      // self.$data.innerStyles[n.index] = self.getInnerStyle(n.shared)
      // console.log(self.$data.innerStyles)
      // self.goToSection(n.index)
    })
    self.adjustTopOffset()
  }
}
</script>

<style lang="scss">
$lightColor: #dddddd;
$darkColor: #333333;
div.section-background{
  width:100%;
  height:100%;
}
div.section-inner{
  position: absolute;
  left: 50%;
  top: 50%;
  > div{
    > div{
      position:absolute;
      margin-bottom: 100px;
      > div,img,ul{
        width:100%;
        height:100%;
      }
      > a{
        width:100%;
        width:100%;
        display:block;
        text-decoration: none !important;
        > div,img,ul{
          width:100%;
          height:100%;
        }
      }
    }
  }
}
ul.section-navigation{
  display: inline-block;
  width: 30px;
  position:fixed;
  top: 5px;
  right: 5px;
  margin:0;
  padding: 8px;
  z-index:1200;
  > li{
    display:block;
    padding:4px;
    margin: 0;
    position:relative;
    opacity: .4;
    > div{
      box-shadow: 0 0 0 2px #ffffff inset;
      width:20px;
      height:20px;
      border-radius:20px;
    }
    > label{
      position: absolute;
      padding-right: 30px;
      right:0;
      top:7px;
      color: #ffffff;
      font-family: Arial, Helvetica, sans-serif;
      text-align: right;
      font-size: 11px;
    }
  }
  > li.active-marker{
    opacity: 1;
    > div{
      background-color: #ffffff;
    }
  }
}
div.main-background{
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
}
iframe.section-bg-video{
  position: absolute;
  top:0;
  left:0;
  min-width:100%;
  min-height: 100%;
  border:none;
}
label.dark-menu{
  color: $darkColor !important;
}
div.dark-menu{
  box-shadow: 0 0 0 1px $darkColor inset, 0 0 0 2px $lightColor inset !important;
}
li.active-marker{
  > div.dark-menu{
    background-color: $darkColor !important;
  }
}
label.light-menu{
  color: $lightColor !important;
}
div.light-menu{
  box-shadow: 0 0 0 2px $lightColor inset !important;
}
li.active-marker{
  > div.light-menu{
    background-color: $lightColor !important;
  }
}
div.mobile-version-player{
  div.inline-section{
    height:100vh !important;
    width: 100vw !important;
    overflow: auto !important;
    div.section-inner{
      margin-top:-250px !important;
      top:0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlayerView.vue